import PropTypes from 'prop-types'

function ImgTemplate({ srcName, alt, width, href, desc }): JSX.Element {
  return (
    <>
      <img src={`/images/${srcName}`} alt={alt} width={width} />
      {href && (
        <a href={href} target='_blank' rel='noreferrer'>
          <i>{href}</i>
        </a>
      )}
      {desc && <i>{desc}</i>}
    </>
  )
}
ImgTemplate.propTypes = {
  srcName: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  width: PropTypes.string,
  href: PropTypes.string,
  desc: PropTypes.string,
}
export default ImgTemplate
